import { render } from "./HeaderComponent.vue?vue&type=template&id=c0fcc046&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=c0fcc046&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fcc046"]])

export default __exports__